import React, { useEffect, useReducer } from "react";
import Form from "./components/Form";
import InputField from "./components/InputField";
import * as yup from "yup";
import { api } from "../../../utils";
import { formReducer } from "../../../utils/stateHandlers/reducers";
import states from "../../../utils/stateHandlers/initialStates";
import { FormContext } from "../../../utils/stateHandlers/contexts";
import SelectField from "./components/SelectField";

const schema = {
  Metal: yup.array().min(1).required("You must select at least one option."),
  Mill: yup.array().min(1).required("You must select at least one option."),
  Findings: yup.array().min(1).required("You must select at least one option."),
  Casting: yup.array().min(1).required("You must select at least one option."),
  Discounts: yup
    .array()
    .min(1)
    .required("You must select at least one option."),
  AnnualPurchases: yup
    .string()
    .required("Please enter an annual precious metal purchasing amount."),
};

export default function MarketingForm(props) {
  const [formState, dispatch] = useReducer(formReducer, states);
  const { isLoaded, fields, formtext, formtitle, submitted } = formState;
  const onSubmit = (data) => console.log(data);

  useEffect(() => {
    api.fetch("forms/marketing/fields").then((response) => {
      console.log(response.data);
      dispatch({
        type: "setFields",
        payload: response.data.fields,
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormContext.Provider value={{ formState, dispatch }}>
      <Form onSubmit={onSubmit} validationObject={schema}>
        {fields &&
          fields.map((field) => (
            <InputField name={field.name} field={field} />
            // <React.Fragment key={field.name}>
            //   {field.template === "text" ? (
            //     <InputField name={field.name} field={field} />
            //   ) : field.template === "dropdown" ? (
            //     <SelectField name={field.name} field={field} />
            //   ) : (
            //     <InputField name={field.name} field={field} />
            //   )}
            // </React.Fragment>
          ))}
      </Form>
    </FormContext.Provider>
  );
}
